import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team, TeamSalesOrderPhase, WorkspaceSalesOrderPhase } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2550. ワークスペース受注フェーズ一覧
 * [GET] /workspaces/:identifier/workspace_sales_order_phases
 */
type Props = {
  identifier: string;
};
const workspaceSalesOrderPhases = (props: Props): Promise<WorkspaceSalesOrderPhase[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/workspace_sales_order_phases`, {
    params: props,
  });
};

export const useWorkspaceSalesOrderPhases = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => workspaceSalesOrderPhases(props),
  });
};

export const useInvalidateWorkspaceSalesOrderPhases = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'workspace_sales_order_phases'];
};
